import { Link } from "react-router-dom";
import { Mail, Phone, Clock } from "lucide-react";
import { CONTACT } from "@/data/products";

const Footer = () => (
  <footer className="bg-ink text-cream pt-16 pb-10 px-6 md:px-12 border-t border-coffee">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <p className="font-hindi text-3xl text-gold">राजकुमारी</p>
        <p className="font-serif font-bold uppercase tracking-tight mt-1">Raj Kumari Kirana Store</p>
        <p className="text-cream/60 text-sm mt-4 leading-relaxed">
          आपकी अपनी दुकान — pure sourcing, honest prices and three decades of neighbourhood trust.
        </p>
      </div>
      <div>
        <p className="uppercase text-xs font-semibold tracking-[0.2em] text-gold mb-5">Explore</p>
        <div className="flex flex-col gap-3 text-sm">
          <Link to="/" className="text-cream/70 hover:text-gold transition-colors">Home</Link>
          <Link to="/about" className="text-cream/70 hover:text-gold transition-colors">About Us</Link>
          <Link to="/contact" className="text-cream/70 hover:text-gold transition-colors">Contact Us</Link>
          <Link to="/privacy" className="text-cream/70 hover:text-gold transition-colors">Privacy Policy</Link>
          <Link to="/disclaimer" className="text-cream/70 hover:text-gold transition-colors">Disclaimer</Link>
        </div>
      </div>
      <div>
        <p className="uppercase text-xs font-semibold tracking-[0.2em] text-gold mb-5">Reach Us</p>
        <div className="flex flex-col gap-3 text-sm">
          <a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="inline-flex items-center gap-2 text-cream/70 hover:text-gold transition-colors">
            <Phone size={15} /> {CONTACT.phone}
          </a>
          <a data-testid="footer-email-link" href={CONTACT.emailHref} className="inline-flex items-center gap-2 text-cream/70 hover:text-gold transition-colors">
            <Mail size={15} /> {CONTACT.email}
          </a>
          <p className="inline-flex items-center gap-2 text-cream/70">
            <Clock size={15} /> {CONTACT.hours}
          </p>
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-coffee/60 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/40">
      <p>© {new Date().getFullYear()} Raj Kumari Kirana Store. All rights reserved.</p>
      <p>शुद्धता और विश्वास — since day one.</p>
    </div>
  </footer>
);

export default Footer;
